import { parseScheduleDocument, scheduleDocument } from "./schedule-json";

const storageKey = "schedule-maker.schedule";

export function loadSavedSchedule() {
  try {
    const json = localStorage.getItem(storageKey);
    return json ? parseScheduleDocument(json) : null;
  } catch {
    return null;
  }
}

export function saveSchedule(state: Parameters<typeof scheduleDocument>[0]) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(scheduleDocument(state)));
    return true;
  } catch {
    return false;
  }
}
